import React from 'react';
import { useFormik } from 'formik';
import { Alert, Box, Link, Typography, IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useManage2faAuthenticator } from './Manage2faEndpoints';
import { QRCodeSVG } from 'qrcode.react';

export default function Manage2faAuthenticatorStep1(props) {
    const authenticator = useManage2faAuthenticator();
    const dialogSubmit = React.useRef(props.dialogSubmit);
    const [copyTooltip, setCopyTooltip] = React.useState('Copy to clipboard');

    const handleCopyKey = () => {
        navigator.clipboard.writeText(authenticator.result?.sharedKey);
        setCopyTooltip('Copied!');
        setTimeout(() => setCopyTooltip('Copy to clipboard'), 2000);
    };

    const formik = useFormik({
        initialValues: {},
        onSubmit: () => {
            props.onValidate(formik?.values);
        },
    });

    React.useEffect(() => {
        if (props.dialogSubmit !== dialogSubmit.current) {
            dialogSubmit.current = props.dialogSubmit;
            formik.handleSubmit();
        }
    });

    return (
        <>
            <Alert sx={{ mt: 2 }} severity="info">
                Download a multi-factor authenticator app like Microsoft Authenticator for <Link href="https://go.microsoft.com/fwlink/?Linkid=825072">Android</Link> and <Link href="https://go.microsoft.com/fwlink/?Linkid=825073">iOS</Link> or Google Authenticator for <Link href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&amp;hl=en">Android</Link> and <Link href="https://itunes.apple.com/us/app/google-authenticator/id388497605?mt=8">iOS</Link>.
                Once installed, scan the QR code and proceed to the next step.
            </Alert>
            <Box
                sx={{
                    mt: 3,
                    textAlign: 'center',
                }}
            >
                <div sx={{ mt: 2, mb: 2}}>
                    <QRCodeSVG
                        value={authenticator.result?.authenticatorUri}
                        size={150}
                    />
                </div>
                <Box sx={{ mt: 2, mb: 2, p: 2, border: '1px solid #e0e0e0', borderRadius: 1, backgroundColor: '#f5f5f5', textAlign: 'left' }}>
                    <Typography variant="subtitle2" gutterBottom>
                        Manual Setup Key
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography variant="body2" sx={{ fontFamily: 'monospace', wordBreak: 'break-all', flex: 1 }}>
                            {authenticator.result?.sharedKey}
                        </Typography>
                        <Tooltip title={copyTooltip} placement="top">
                            <IconButton 
                                onClick={handleCopyKey}
                                size="small"
                                color="primary"
                                aria-label="copy setup key"
                            >
                                <ContentCopyIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </Box>
                    <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                        Enter this key manually if you can't scan the QR code. Spaces and casing do not matter.
                    </Typography>
                </Box>
            </Box>
        </>
    );
}